module.exports = __webpack_public_path__ + "img/faq2.ea48aa3a.png";